import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { getPropsByKeyPath } from 'src/shared/helpers/objHelpers';
export var RefusedItem = function (props) {
    var i18n = props.i18n, refusedCase = props.refusedCase;
    var author = refusedCase.author, cancellationCode = refusedCase.cancellationCode;
    var description = getPropsByKeyPath(i18n, 'modules.timeline.refusedCase.textAction')
        .replace('$username ', '')
        .replace('$moStatusDetails', '');
    var authorLabel = (author === null || author === void 0 ? void 0 : author.login) || getPropsByKeyPath(i18n, 'modules.timeline.defaultUser');
    var translatedReasonOfRefusal = getPropsByKeyPath(i18n, "keyValueMap.filter.moStatus.details.".concat(cancellationCode));
    var reasonOfRefusal = translatedReasonOfRefusal ? translatedReasonOfRefusal : cancellationCode;
    return (_jsx(_Fragment, { children: _jsxs("p", { children: [_jsx("b", { children: authorLabel }), " ", description, " ", _jsx("b", { children: reasonOfRefusal })] }) }));
};
